import React from 'react'

import BG_ICON from '@public/assets/img_popup_create.svg'

interface TimeEntryDialogHeaderProps {
  mode?: 'normal' | 'review'
  title?: React.ReactNode
  onClose: () => void
  disabled?: boolean
}

const HEADER_CONFIG = {
  normal: {
    title: 'Time Entry',
    bgColor: 'bg-[#DFD4F6]',
    borderColor: 'border-b border-[#D9D9D9]',
    textColor: 'text-[#141414]',
    closeColor: '#4F3A73',
  },
  review: {
    title: 'Original Time Entry',
    bgColor: 'bg-[#1B4EA7]',
    borderColor: '',
    textColor: 'text-[#fff]',
    closeColor: '#FFFFFF',
  },
}

const TimeEntryDialogHeader = ({
  mode = 'normal',
  title,
  onClose,
  disabled = false,
}: TimeEntryDialogHeaderProps) => {
  const config = HEADER_CONFIG[mode]

  return (
    <div
      className={`relative flex h-20 shrink-0 items-center justify-between rounded-t-xl ${config.borderColor} ${config.bgColor}`}
    >
      <div className="flex items-center gap-2.5">
        <img src={BG_ICON} className="h-20 rounded-tl-xl" alt="" />
        <div className="flex flex-col items-start gap-1">
          <span
            className={`text-lg font-semibold leading-[30px] ${config.textColor}`}
          >
            {title ?? config.title}
          </span>
        </div>
      </div>

      <button
        type="button"
        onClick={onClose}
        disabled={disabled}
        className="absolute right-4 cursor-pointer border-0 bg-transparent text-base text-[#555]"
        aria-label="Close"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M4.79988 14.3934L3.60645 13.2L7.80645 9.00001L3.60645 4.80001L4.79988 3.60657L8.99988 7.80657L13.1999 3.60657L14.3933 4.80001L10.1933 9.00001L14.3933 13.2L13.1999 14.3934L8.99988 10.1934L4.79988 14.3934Z"
            fill={config.closeColor}
          />
        </svg>
      </button>
    </div>
  )
}

export default TimeEntryDialogHeader
